export enum TrafficTypeEnum {
  VOICE = 'voice',
  DATA = 'data',
  TV = 'tv'
}
